import React from 'react';
import ProjectEmbed from '../components/ProjectEmbed';

const RobotProject = () => (
    <ProjectEmbed
        title='3lb Combat Robot "Arpox"'
        src="/projects/arpox/3lb-combat-robot-final.html"
    />
);

export default RobotProject;
